/** common scripts entrypoint, used for both admin and frontend */
import { camelCase } from 'lodash';
import dayjs from "dayjs";
import LocalizedFormat from 'dayjs/plugin/localizedFormat'; // import plugin
import utc from 'dayjs/plugin/utc'; // import plugin
import timezone from 'dayjs/plugin/timezone'; // import plugin
import relativeTime from 'dayjs/plugin/relativeTime'; // import plugin
import isToday from 'dayjs/plugin/isToday'; // import plugin
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(LocalizedFormat);
dayjs.extend(relativeTime);
dayjs.extend(isToday);
// TODO function was copied from apps, also see addCommaToNumber as it does the same thing, need to standardise on one
export const addThousandSeparator = (number) => {
    number = number.toString();
    const decimalSeparator = '.';
    const thousandSeparator = ',';
    let splittedNumber = number.split(decimalSeparator);
    splittedNumber[0] = splittedNumber[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    return splittedNumber.join(decimalSeparator);
};
export const formatDistance = (number, decimalPlaces = 1) => {
    number = number.toString();
    return addThousandSeparator(parseFloat(number).toFixed(decimalPlaces));
};
export const formatDistanceScaled = (number) => {
    number = number.toString();
    const f = parseFloat(number);
    let decimalPlaces;
    if (f > 1000) {
        decimalPlaces = 0;
    }
    else if (f > 100) {
        decimalPlaces = 1;
    }
    else {
        decimalPlaces = 2;
    }
    return addThousandSeparator(f.toFixed(decimalPlaces));
};
export const checkIfUnderAge = () => {
    // @ts-ignore
    return window?.underAge == 1 ? true : false;
};
const getValueCamelCasedIfObject = (value) => {
    // Explicitly check `null` to prevent casting to object
    if (value === null) {
        return value;
    }
    // if string, number, bool: return pure value
    if (typeof value !== 'object') {
        return value;
    }
    // if jsonObject: convert snake to camel case
    if (!Array.isArray(value)) {
        return snakeToCamelCase(value);
    }
    // if array: loop through and check for above conditions
    return value.map((arrayItem) => {
        return getValueCamelCasedIfObject(arrayItem);
    });
};
/** Use this function with caution. Large objects may cause performance issue */
const snakeToCamelCase = (obj, keysToIgnore) => {
    let camelCaseObj = {};
    for (const key in obj) {
        if (keysToIgnore?.includes(key)) {
            continue;
        }
        let value = getValueCamelCasedIfObject(obj[key]);
        const camelCaseKey = camelCase(key);
        camelCaseObj = {
            ...camelCaseObj,
            [camelCaseKey]: value,
        };
    }
    return camelCaseObj;
};
export { snakeToCamelCase };
document.querySelectorAll('.js-datetime').forEach(elem => {
    const ts = parseInt(elem.getAttribute('data-timestamp') ?? '0');
    const day = dayjs.unix(ts);
    const d = day.format("ll");
    const t = day.format("LT");
    let html;
    if (ts > 0) {
        html = '<div class="">' + d + '</div>'
            + '<div class="small text-muted">' + t + '</div>';
    }
    else {
        html = '<div class="text-muted">(never)</div>';
    }
    elem.innerHTML = html;
});
document.querySelectorAll('.js-datetime-relative').forEach(elem => {
    const ts = parseInt(elem.getAttribute('data-timestamp') ?? '0');
    let html;
    if (ts > 0) {
        const day = dayjs.unix(ts);
        let d;
        let t;
        d = day.format("ll");
        if (day.isToday()) {
            t = day.fromNow();
            const title = day.format("LT");
            html = '<div class="">' + d + '</div>'
                + '<div class="small text-muted" title="' + title + '">' + t + '</div>';
        }
        else {
            t = day.format("LT");
            html = '<div class="">' + d + '</div>'
                + '<div class="small text-muted">' + t + '</div>';
        }
    }
    else {
        html = '<div class="text-muted">(never)</div>';
    }
    elem.innerHTML = html;
});
document.querySelectorAll('.js-date').forEach(elem => {
    const ts = parseInt(elem.getAttribute('data-timestamp') ?? '0');
    const day = dayjs.unix(ts);
    const d = day.format("ll");
    let html;
    if (ts > 0) {
        html = '<div class="">' + d + '</div>';
    }
    else {
        html = '<div class="text-muted">(never)</div>';
    }
    elem.innerHTML = html;
});
document.querySelectorAll('.js-timezone').forEach(elem => {
    elem.innerHTML = dayjs.tz.guess();
});
